export default "/images/vendor/flag-icon-css/flags/1x1/hr.svg?85eb7e0d4ea914241924c0b0321f34e2";